import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWorkflowLanes20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconWorkflowLanes20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 3H3a.5.5 0 0 0-.5.5v2h5v-2A.5.5 0 0 0 7 3m2 2.5V17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2zm-1.5 8V11h-5v2.5zm-5 1.5h5v2a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5zm5-8v2.5h-5V7zM17 3h-4a.5.5 0 0 0-.5.5v2h5v-2A.5.5 0 0 0 17 3m-6 2.5V13a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2zm1.5 5.5v2a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-2zm5-1.5V7h-5v2.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWorkflowLanes20);
